// utils
import scroll from './scroll-lock';

const modals = [...document.querySelectorAll('.modal')];

const modalOpenClass = 'modal--open';
const modalOverlayOpenClass = 'modal__overlay--show';
const modalOverlayId = 'modal-overlay';

// Get the modal overlay element.
const getOverlay = () => document.getElementById(modalOverlayId);

// Close all modals if clicked on overlay.
const toggleOverlay = (overlay, forceClose = false) => {
  const isOverlay = overlay.classList.contains(modalOverlayOpenClass);
  if (forceClose) {
    overlay.classList.remove(modalOverlayOpenClass);
  } else {
    overlay.classList.toggle(modalOverlayOpenClass, !isOverlay);
  }
};

// Open a modal.
export const openModal = (modal, overlay = getOverlay()) => {
  // prevents page scrolling
  // @todo, bc of how this operates, elements dependent on scroll move
  // I think we had to have the current setup bc of some bugs
  // on ios, so research that, it will also stop bugging His Majesty
  scroll.lock();
  // close all opened modals, in case something is open
  modals.forEach((m) => m.classList.remove(modalOpenClass));
  // add open class to the modal -> adds CSS to show it
  modal.classList.add(modalOpenClass);
  // toggle display of the overlay (reused, for all modals)
  toggleOverlay(overlay);
};

// Close a modal.
export const closeModal = (modal, overlay = getOverlay()) => {
  // allow page scrolling again
  scroll.unlock();
  // remove the class making the modal visible fo the user
  modal.classList.remove(modalOpenClass);
  // hide the overlay
  toggleOverlay(overlay, true);
};

// Allow closing with Escape key.
export const allowClosingWithEsc = (modal, overlay = getOverlay()) => {
  window.addEventListener('keyup', ({ key }) => {
    const isOpen = modal.classList.contains(modalOpenClass);
    // close a modal if open
    // @todo should we close all?
    if (isOpen && key === 'Escape') {
      closeModal(modal, overlay);
    }
  });
};

// Toggle a modal.
export const toggleModal = (modal, button, triggerBtnClick = false) => {
  const closeButton = modal.querySelector('.modal__close');

  [button, closeButton, getOverlay()].forEach((selector) => {
    if (selector !== null) {
      selector.addEventListener('click', ({ target }) => {
        const isOpen = modal.classList.contains(modalOpenClass);
        const shouldClose = ['modal__close', 'modal-overlay'].some((cName) =>
          target.classList.contains(cName),
        );

        if (isOpen || shouldClose) {
          closeModal(modal);
        } else {
          openModal(modal);
        }
      });
    }
  });

  if (triggerBtnClick) {
    button.click();
  }

  // add Esc key listener.
  allowClosingWithEsc(modal);
};
